// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1jfuc","label":"Completed_label__1cJIW"};